<div class="flex flex-col justify-between py-4 ps-8">
    <div class="top-1/2 left-0 absolute border-gray-300 border-l-2 border-dashed w-2 h-4/5 -translate-y-1/2"></div>
    <div class="flex flex-col gap-6">
        <div class="flex w-fit date-flag">
            <p class="text-sm">{{notizia.data_creazione | date: 'dd MMM' | titlecase}}</p>
        </div>        
        <div class="info">            
            <h1 class="mb-4 font-medium text-black text-xl lg:text-2xl">{{notizia.titolo | titlecase}}</h1>            
            <p class="mb-0 line-clamp-5 font-mono text-base text-left desc" [innerHTML]="notizia.descrizione"></p>
        </div>
    </div>
    <div class="mt-5 buttons">
        <a class="cta-link" routerLink="/news/{{notizia.url}}" *ngIf="!notizia.link">SCOPRI DI PIÙ</a>
        <a class="cta-link" [href]="notizia.link_url" *ngIf="notizia.link">SCOPRI</a>
    </div>
</div>